import { TAsqPayload } from 'types/TAsq';

export const GaFields: Partial<Record<keyof TAsqPayload, string>> = {
  buyerName: 'NAAM',
  location: 'WOONPLAATS',
  buyerPhoneNumber: 'TELEFOONNUMMER',
  vehicleTradeInRequest: 'INRUILVOORSTEL',
};

export const AsqHashParams = {
  SHOW_ASQ: {
    KEY: 'action',
    VALUE: 'showAsq',
  },
  MESSAGE_TYPE: {
    KEY: 'asqMessageType',
    VALUES: {
      TEST_DRIVE: 'testDrive',
      CALL_BACK: 'callBack',
    },
  },
  PREVIOUS_ACTION: {
    KEY: 'previousAction',
    VALUES: {
      LOGIN: 'login',
      TEST_DRIVE: 'testDrive',
      CALL_BACK: 'callBack',
    },
  },
};

export const testDriveSchedulerDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const testDriveSchedulerTimeSlots = [
  { start: '9:00', end: '12:00' },
  { start: '12:00', end: '15:00' },
  { start: '15:00', end: '18:00' },
];
